// Resolve window.requestAnimationFrame at CALL time (not module load), so tools
// that wrap rAF for diagnostics (frame timing, tests) see the game's loops too.
function requestFrame(callback) {
    if (window.requestAnimationFrame) {
        return window.requestAnimationFrame(callback);
    }
    // window.setTimeout (not the bare global): its DOM typing returns number, so
    // callers can keep the handle in a plain number alongside rAF ids.
    return window.setTimeout(callback, 0);
}

export default requestFrame;
